import {
  checkboxGroupSchema,
  checkboxGroupUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import {
  SERVICE_COMPONENT_LABELS,
  CHECKBOXGROUP_HINT_TEXT,
} from '../../constants';

export default {
  uiSchema: {
    ...titleUI('Components you’ve served in'),
    serviceInformation: {
      serviceComponent: checkboxGroupUI({
        title: 'Which components have you served in?',
        hint: CHECKBOXGROUP_HINT_TEXT,
        labels: SERVICE_COMPONENT_LABELS,
        required: true,
      }),
    },
  },
  schema: {
    type: 'object',
    required: ['serviceInformation'],
    properties: {
      serviceInformation: {
        type: 'object',
        required: ['serviceComponent'],
        properties: {
          serviceComponent: checkboxGroupSchema(
            Object.keys(SERVICE_COMPONENT_LABELS),
          ),
        },
      },
    },
  },
};
